import { style, styleVariants } from '@vanilla-extract/css';
import { brightTokens } from '../../tokens';
import { vars } from '../../theme/contract.css';

export const base = style({
  display: 'inline-block',
  borderRadius: '50%',
  flexShrink: 0,
});

/**
 * 등급 계단 — 크기(`RarityDot.tsx` RARITY_SIZE)와 짝을 이룬다.
 *
 * glow 반경과 보더 알파가 등급과 함께 오른다. common 만 glow 를 갖지 않는데,
 * 목록의 38.9%(실측)가 빛나지 않아야 나머지가 뜨기 때문이다 — 전부 빛나면
 * 아무것도 빛나지 않는다.
 *
 * TIER 2 상한이 점 내부라 모션은 여기 없다(`DESIGN.md` §Visual Hierarchy Rules).
 * 등급 모션은 상세 패널의 `QuestDetailBody.css.ts` `panelGlow` 에만 존재한다 —
 * 스크롤하는 목록에서 N 개가 동시에 펄스하는 비용은 상세의 하나와 비교되지 않는다.
 */
export const rarityStyles = styleVariants({
  common: {
    background: brightTokens.rarity.common,
  },
  uncommon: {
    background: brightTokens.rarity.uncommon,
    boxShadow: `0 0 3px ${brightTokens.rarity.uncommon}`,
    border: `1px solid ${vars.opacityScale.whiteOverlay.medium}`,
  },
  rare: {
    background: brightTokens.rarity.rare,
    boxShadow: `0 0 4px ${brightTokens.rarity.rare}`,
    border: `1px solid ${vars.opacityScale.whiteOverlay.strong}`,
  },
  epic: {
    background: brightTokens.rarity.epic,
    boxShadow: `0 0 6px ${brightTokens.rarity.epic}`,
    border: `1px solid ${vars.opacityScale.whiteOverlay.heavy}`,
  },
  legendary: {
    background: brightTokens.rarity.legendary,
    boxShadow: `0 0 9px ${brightTokens.rarity.legendary}`,
    border: `2px solid ${vars.opacityScale.whiteOverlay.veryStrong}`,
  },
});
